import { extend } from 'vee-validate'
import {
  required as rule_required,
  required_if as rule_required_if,
  email as rule_email,
  max as rule_max,
  min as rule_min,
  confirmed as rule_confirmed,
  regex as rule_regex,
  between as rule_between,
  alpha as rule_alpha,
  integer as rule_integer,
  digits as rule_digits,
  alpha_dash as rule_alpha_dash,
  alpha_num as rule_alpha_num,
  length as rule_length,
  image as rule_image,
} from 'vee-validate/dist/rules'

import i18n from '@/libs/i18n'

import {
  validatorLikePhone,
  validatorTextNumSpaceDash,
} from './validators.js'


// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////

export const required = extend('required', {
  ...rule_required,
  message: i18n.t('error.required'),
})

// eslint-disable-next-line camelcase
export const required_if = extend('required_if', rule_required_if)

export const email = extend('email', rule_email)

export const max = extend('max', rule_max)

export const min = extend('min', rule_min)

export const confirmed = extend('confirmed', rule_confirmed)

export const regex = extend('regex', rule_regex)

export const between = extend('between', rule_between)

export const alpha = extend('alpha', rule_alpha)

export const integer = extend('integer', rule_integer)

export const digits = extend('digits', rule_digits)

export const alphaDash = extend('alpha-dash', rule_alpha_dash)

export const alphaNum = extend('alpha-num', rule_alpha_num)

export const length = extend('length', rule_length)

export const images = extend('images', rule_image)

export const likePhone = extend('likePhone', {
  validate: validatorLikePhone,
  message: i18n.t('error.phone'),
})

export const textNumSpaceDash = extend('textNumSpaceDash', {
  validate: validatorTextNumSpaceDash,
  message: i18n.t('error.num-space-dash'),
})
